// Interface translations. Keys are flat dot-paths and identical across locales.
// {var} interpolation is handled by the LanguageContext t() helper.
import en from "./locales/en";
import es from "./locales/es";
import fr from "./locales/fr";
import pt from "./locales/pt";
import de from "./locales/de";

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "es", label: "Español", short: "ES" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "pt", label: "Português (BR)", short: "PT" },
  { code: "de", label: "Deutsch", short: "DE" },
];

export const translations = { en, es, fr, pt, de };
